import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { brandActions } from "../../../redux/actions/brand-actions";
import { confirmAlert } from "react-confirm-alert";
import Confirmalertfordelete from "../../ThemeComponents/confirmAlertForDelete";
import { brandService } from "../../../services/brand";
import { alertActions } from "../../../redux/actions/alert-actions";

class CustomerBrandPermissions extends Component {

    constructor(props) {
        super(props);

        this.state = {
            brandPermissions: []
        }

    }

    editVendorId(row, index) {
        const temp = [...this.state.brandPermissions];
        temp[index].disabled = false;
        this.setState({
            brandPermissions: temp
        })
    }

    handleInput(e, row, index) {
        if (!row.disabled) {
            const temp = [...this.state.brandPermissions];
            temp[index].pivot.vendor_id = e.target.value;
            this.setState({
                brandPermissions: temp
            })
        }
    }

    async saveVendorId(e, row, index) {
        try {
            let res = await brandService.editBrandVendorId(this.state.brandPermissions[index].id, this.props.customer_id, { vendor_id: this.state.brandPermissions[index].pivot.vendor_id })
            this.props.fetchBrandAccess(this.props.customer_id);
            this.props.successAlert(res.message);
        } catch (e) {
            this.props.errorAlert(e.message);
        }
    }

    componentDidMount() {
        this.setState({
            brandPermissions: this.props.brandPermissions
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.brandPermissions !== prevProps.brandPermissions && this.props.brandPermissions.length > 0) {
            this.setState({
                brandPermissions: this.props.brandPermissions
            })
        }
    }


    renderList() {
        return this.state.brandPermissions.map((row, index) => {
            return (
                <tr key={index}>
                    {
                        row &&
                        <React.Fragment>
                            <td>{row.title !== null ? row.title : ''}</td>
                            <td>
                                <React.Fragment>
                                    <input className="form-control" style={{ width: "50%" }} type={'text'}
                                        value={row.pivot ? row.pivot.vendor_id : ''}
                                        onChange={(e) =>
                                            this.handleInput(e, row, index)
                                        }
                                        disabled={row.disabled}
                                    />
                                    {
                                        !row.disabled &&
                                        <button type="button" style={{ width: 'auto' }}
                                            className="customBtn pt-xs pb-xs mt-xs pr-sm pl-sm btnBlue"
                                            onClick={(e) => {
                                                this.saveVendorId(e, row, index)
                                            }}
                                        >Save
                                        </button>
                                    }
                                </React.Fragment>
                            </td>
                            <td>
                                <OverlayTrigger
                                    placement="bottom"
                                    overlay={<Popover id="tooltip">Edit Vendor ID</Popover>}
                                >
                                    <span>
                                        <button
                                            onClick={() => this.editVendorId(row, index)}
                                            className="editIcon orderDetailsAction"
                                        >
                                            &nbsp;
                                        </button>
                                    </span>
                                </OverlayTrigger>

                                <OverlayTrigger
                                    placement="bottom"
                                    overlay={<Popover id="tooltip">Delete Row</Popover>}
                                >
                                    <span>
                                        <button
                                            onClick={() => this.deleteConfirmItem(row)}
                                            className="deleteIcon orderDetailsAction"
                                        >
                                            &nbsp;
                                        </button>
                                    </span>
                                </OverlayTrigger>
                            </td>
                        </React.Fragment>
                    }
                </tr>
            );
        }
        );
    }

    deleteConfirmItem(row) {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <Confirmalertfordelete
                        typeName="Brand Access"
                        description={
                            "Are you sure to delete the" + row.title
                        }
                        onClosePro={onClose}
                        deleteType={() =>
                            this.props.deleteCustomerbRrandCall(row.pivot.brand_id, row.pivot.customer_id)
                        }
                    />
                );
            }
        });
    }

    render() {
        const tableRows = this.renderList();
        return (
            <React.Fragment>
                <table className="table theme_table mt-xlg">
                    <thead>
                        <tr>
                            <td>Brand Name</td>
                            <td>External Vendor ID</td>
                            <td>Control</td>
                        </tr>
                    </thead>
                    <tbody>{tableRows}</tbody>
                </table>
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        deleteCustomerbRrandCall: (brand_id, customer_id) => {
            dispatch(brandActions.deleteCustomerBrand(brand_id, customer_id));
        },
        errorAlert: (e) => {
            dispatch(alertActions.error(e))
        },
        successAlert: (msg) => {
            dispatch(alertActions.success(msg))
        },
    };
}
    ;

const mapStateToProps = state => {
    const { brands } = state.brandReducer;
    return {
        brands: brands.brands,
    };
}
    ;

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(CustomerBrandPermissions)
);



// WEBPACK FOOTER //
// ./src/components/Admin/Customers/CustomerBrandPermissions.jsx